import React, { useState } from 'react';

import {useModal} from '../../hooks';
import Modal from '../Modal';
import IntegrationControl from './IntegrationControl';

const IntegrationModal = ({
  gameId
}) => {
  const [modal, modalSet] = useModal({ keyboardBidnings: true })
  const toggleModal = () => modalSet(!modal)
  const path = `/${gon.currentProvider}/api/games/${gameId}/integrations/game8`
  return (
    <React.Fragment>
      <a
        title='Manage Integrations'
        className='Table__controls__a Table__controls__a--integration'
        onClick={toggleModal}
      />

      <Modal isActive={modal} onToggleModal={() => modalSet(false)} reset>
        <div className='IntegrationModal'>
          <h3 className='Modal__h3'>Integrations</h3>
          <IntegrationControl path={path} onSubmit={toggleModal} integrationName='Game 8' />
        </div>

        <div className='Modal__footer Modal__footer--without-border'>
          <a
            className='Button Button--gray'
            onClick={toggleModal}
          >
            Back
          </a>
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default IntegrationModal;
